import React from 'react'
import { Box } from '@mui/material';
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
// import SherbetLogo  from '../../../styles/images/sb-logo.png';
import SherbetMainLogo from "../../../styles/images/sherbet-main-logo.png"

export function AuthWrapper(props) {

    const { heading, children } = props;

    return (
        <>
            <div className='sba-auth-wr'>
                <Container component="main"  className='sba-auth-main'>
                    <Box
                        sx={{
                            boxShadow: 3,
                            borderRadius: 2,
                            px: 4,
                            py: 4,
                            paddingTop: 4,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                        className='sba-auth-box'
                    >
                        <img src={SherbetMainLogo}/>
                        <Typography component="h1" variant="h5" sx={{ mb: 1, mt: 1 }} className="sba-auth-heading">
                            {heading}
                        </Typography>
                        {children}
                    </Box>
                </Container>
            </div>

        </>
    )
}
